import { animate, timeline } from 'motion';

import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      caseStudiesTabButton: this.el,
      overlay: this.el.querySelector('.overlay'),
      text: this.el.querySelector('.case-studies-tab__button .text')
    };
  }

  addListeners() {
    this.dom.caseStudiesTabButton.addEventListener(
      'mouseenter',
      this.handleHoverIn.bind(this)
    );
    this.dom.caseStudiesTabButton.addEventListener(
      'mouseleave',
      this.handleHoverOut.bind(this)
    );
  }

  handleHoverIn() {
    const sequence = [
      [
        this.dom.text,
        {
          opacity: [1, 0],
          transform: ['translate(0, 0)', 'translate(100px, 0)'],
          color: '#fff'
        },
        { duration: 0.15, delay: 0.05 }
      ],
      [
        this.dom.text,
        {
          opacity: [0, 1],
          transform: ['translate(-100px, 0)', 'translate(0, 0)']
        },
        { at: 0.17 + 0.05 },
        { duration: 0.15, delay: 0.05 }
      ]
    ];

    timeline(sequence);

    animate(
      this.dom.overlay,
      { transform: 'scale(2, 1)' },
      { duration: 0.7 }
    ).finished.then(() => {});
  }

  isActiveButton() {
    return this.dom.text
      .closest('.case-studies-tab__button')
      .classList.contains('job-listing__cta--active');
  }

  handleHoverOut() {
    const sequence = [
      [
        this.dom.text,
        {
          opacity: [1, 0],
          transform: ['translate(0, 0)', 'translate(-100px, 0)'],
          color: '#1c1c1c'
        },
        { duration: 0.15, delay: 0.05 }
      ],
      [
        this.dom.text,
        {
          opacity: [0, 1],
          transform: ['translate(100px, 0)', 'translate(0, 0)']
        },
        { at: 0.17 + 0.05 },
        { duration: 0.15, delay: 0.05 }
      ]
    ];

    timeline(sequence).finished.then(() => {
      if (this.isActiveButton()) {
        this.dom.text.style.removeProperty('color');
      }
    });

    animate(
      this.dom.overlay,
      { transform: 'scale(0, 1)' },
      { duration: 0.7 }
    ).finished.then(() => {});
  }
}

export default Module;
